import React from 'react';
import { Skeleton } from '@/common/components/ui/skeleton';
import { ChevronRightIcon } from '@/assets/icons/chevron';

export default function CourseOverviewSkeleton() {
  return (
    <div className='w-full flex flex-col max-w-6xl mx-auto px-6 gap-4'>
      {/* Header with controls skeleton */}
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-3'>
          {/* Expand/Collapse button skeleton */}
          <div
            className='flex items-center gap-2 px-4 py-2 text-xs font-semibold'
            style={{
              borderRadius: '8px',
              border: '1px solid #D5D7DA',
              background: '#FFF',
              boxShadow: '0 1px 3px 0 rgba(10, 13, 18, 0.10), 0 1px 2px 0 rgba(10, 13, 18, 0.06)',
            }}
          >
            <ChevronRightIcon className='w-4 h-4 text-gray-300' />
            <Skeleton className='h-4 w-20' />
          </div>
        </div>

        {/* Stats skeleton */}
        <div className='flex flex-col md:flex-row items-center gap-1'>
          <Skeleton className='h-4 w-12' />
          <span className='text-xs font-semibold text-gray-300 hidden md:block'>•</span>
          <Skeleton className='h-4 w-16' />
        </div>
      </div>

      {/* Units Grid - 3 collapsed units */}
      <div className='space-y-6'>
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className='w-full'>
            {/* Unit Card Skeleton */}
            <div
              className='w-full p-6 border border-gray-200 rounded-3xl bg-white shadow-sm'
              style={{
                boxShadow: '0 1px 3px 0 rgba(10, 13, 18, 0.10), 0 1px 2px 0 rgba(10, 13, 18, 0.06)',
              }}
            >
              {/* Unit Header */}
              <div className='flex items-center justify-between'>
                <div className='flex items-center gap-3'>
                  <ChevronRightIcon className='w-5 h-5 text-gray-300' />
                  <div className='flex flex-col gap-2'>
                    <Skeleton className='h-6 w-32' />
                    <Skeleton className='h-4 w-48' />
                  </div>
                </div>

                {/* Unit stats */}
                <div className='flex items-center gap-2'>
                  <Skeleton className='h-4 w-16' />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom spacing */}
      <div className='h-16' />
    </div>
  );
}
